export const SNACK_AUTO_HIDE_DELAY = 4000;
